/** Must match srishiv_backend/constants/gender.js GENDER_ENUM */
export const GENDER_VALUES = Object.freeze(['Male', 'Female', 'Other']);

export const GENDER_SELECT_OPTIONS = Object.freeze([
  { value: '', label: 'Prefer not to say' },
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
]);
